import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren & {
    isOpen: boolean;
    header?: string;
    confirmButtonColor?: "primary" | "danger";
    isLoading?: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const ConfirmDialog = ({
    isOpen,
    header = "Предупреждение",
    confirmButtonColor = "primary",
    isLoading = false,
    onClose,
    onConfirm,
    children,
}: Props) => {
    return (
        <Modal centered isOpen={isOpen} toggle={isLoading ? undefined : onClose}>
            <ModalHeader toggle={isLoading ? undefined : onClose}>{header}</ModalHeader>
            <ModalBody>{children}</ModalBody>
            <ModalFooter className="adaptive-mobile">
                <Col>
                    <Button onClick={onClose} disabled={isLoading}>
                        Отмена
                    </Button>
                </Col>
                <Col>
                    <Button color={confirmButtonColor} onClick={onConfirm} disabled={isLoading}>
                        {isLoading && <Spinner size="sm" className="me-2" />}
                        Да
                    </Button>
                </Col>
            </ModalFooter>
        </Modal>
    );
};
